import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../components/Login';
import HomePage from '../components/HomePage';
import MainWindow from '../components/MainWindow';
import SystemSetting from '../components/system/SystemSetting';
import BasicUser from '../components/system/BasicUser';
import Role from '../components/system/Role';
import Module from '../components/system/Module';
import RoleModule from '../components/system/RoleModule';
import UserModule from '../components/system/UserModule';
import Password from '../components/system/Password';

import OpenAccount from '../components/merchant/OpenAccount.vue';
import CancelAccount from '../components/merchant/CancelAccount.vue';
import CancelAccountRecord from '../components/merchant/CancelAccountRecord.vue';
import OpenAccountRecord from '../components/merchant/OpenAccountRecord.vue';
import AddSellElctric from '../components/electricity/AddSellElctric.vue';
import CancelSellElectric from '../components/electricity/CancelSellElectric.vue';
import SellElectricRecord from '../components/electricity/SellElectricRecord.vue';
import CancelSellWater from '../components/water/CancelSellWater.vue';
import AddSellWater from '../components/water/AddSellWater.vue';
import SellWaterRecord from '../components/water/SellWaterRecord.vue';
import PrintViewWater from '../components/water/PrintViewWater.vue';
import PrintViewWaterMerge from '../components/water/PrintViewWaterMerge.vue';
import MerchantInfo from '../components/property/MerchantInfo.vue';
import BasicParameters from '../components/system/BasicParameters.vue';
import MeterSetting from '../components/property/MeterSetting.vue';
import WaterSetting from '../components/property/WaterSetting.vue';
import ControlManage from '../components/property/ControlManage.vue';
import PrintView from '../components/electricity/PrintView.vue';
import PrintViewMerge from '../components/electricity/PrintViewMerge.vue';
import ElectricReport from '../components/report/ElectricReport.vue';
import BillManage from '../components/property/BillManage.vue';
import WaterReport from '../components/report/WaterReport.vue';
import AreaManage from '../components/property/AreaManage.vue';
import NBCard from '../components/property/NBCard.vue';
import DataReport from '../components/report/DataReport.vue';
import ParamsManage from '../components/property/ParamsManage.vue';
import Dictionary from '../components/system/Dictionary.vue';
import BasicExcelTemplate from '../components/property/BasicExcelTemplate.vue';
import CompareReport from '../components/report/CompareReport.vue';
import EnergyConsumptionReport from '../components/report/EnergyConsumptionReport.vue';
import BlacklistManagement from '../components/property/BlacklistManagement.vue';
import PersonnelManagement from '../components/property/PersonnelManagement.vue';
import PriceManagement from '../components/property/PriceManagement.vue';
import ConcentratorManagement from '../components/property/ConcentratorManagement.vue';
import AppletAccount from '../components/property/AppletAccount.vue';

Vue.use(VueRouter);
const routes = [{
		path: '/',
		redirect: '/login',
		// component: Test
	},
	{
		path: '/login',
		component: Login,
	},
	{
		path: '/printView',
		component: PrintView,
	},
	{
		path: '/printViewMerge',
		component: PrintViewMerge,
	},
	{
		path: '/printViewWater',
		component: PrintViewWater,
	},
	{
		path: '/printViewWaterMerge',
		component: PrintViewWaterMerge,
	},
	{
		path: '/mainWindow',
		component: MainWindow,
		children: [{
				path: 'homePage',
				component: HomePage,
			},
			{
				path: 'systemSetting',
				component: SystemSetting,
				meta: {
					name: '系统设置',
					comp: SystemSetting,
				},
			},
			{
				path: 'basicUser',
				component: BasicUser,
				meta: {
					name: '用户管理',
					comp: BasicUser,
				},
			},
			{
				path: 'role',
				component: Role,
				meta: {
					name: '角色管理',
					comp: Role,
				},
			},
			{
				path: 'module',
				component: Module,
				meta: {
					name: '菜单管理',
					comp: Module,
				},
			},
			{
				path: 'roleModule',
				component: RoleModule,
				meta: {
					name: '角色权限管理',
					comp: RoleModule,
				},
			},
			{
				path: 'userModule',
				component: UserModule,
				meta: {
					name: '用户权限管理',
					comp: UserModule,
				},
			},
			{
				path: 'password',
				component: Password,
				meta: {
					name: '密码管理',
					comp: Password,
				},
			},

			{
				path: 'openAccount',
				component: OpenAccount,
				meta: {
					name: '商户开户',
					comp: OpenAccount,
				},
			},
			{
				path: 'openAccountRecord',
				component: OpenAccountRecord,
				meta: {
					name: '开户记录查询',
					comp: OpenAccountRecord,
				},
			},
			{
				path: 'cancelAccount',
				component: CancelAccount,
				meta: {
					name: '商户销户',
					comp: CancelAccount,
				},
			},
			{
				path: 'cancelAccountRecord',
				component: CancelAccountRecord,
				meta: {
					name: '销户记录查询',
					comp: CancelAccountRecord,
				},
			},
			{
				path: 'addSellElctric',
				component: AddSellElctric,
				meta: {
					name: '新增售电',
					comp: AddSellElctric,
				},
			},
			{
				path: 'cancelSellElectric',
				component: CancelSellElectric,
				meta: {
					name: '新增退电',
					comp: CancelSellElectric,
				},
			},
			{
				path: 'sellElectricRecord',
				component: SellElectricRecord,
				meta: {
					name: '售电查询',
					comp: SellElectricRecord,
				},
			},
			{
				path: 'addSellWater',
				component: AddSellWater,
				meta: {
					name: '新增售水',
					comp: AddSellWater,
				},
			},
			{
				path: 'cancelSellWater',
				component: CancelSellWater,
				meta: {
					name: '新增退水',
					comp: CancelSellWater,
				},
			},
			{
				path: 'sellWaterRecord',
				component: SellWaterRecord,
				meta: {
					name: '售水查询',
					comp: SellWaterRecord,
				},
			},
			{
				path: 'merchantInfo',
				component: MerchantInfo,
				meta: {
					name: '商户信息管理',
					comp: MerchantInfo,
				},
			},
			{
				path: 'basicParameters',
				component: BasicParameters,
				meta: {
					name: '基本参数设置',
					comp: BasicParameters,
				},
			},
			{
				path: 'meterSetting',
				component: MeterSetting,
				meta: {
					name: '电表设置',
					comp: MeterSetting,
				},
			},
			{
				path: 'waterSetting',
				component: WaterSetting,
				meta: {
					name: '水表设置',
					comp: WaterSetting,
				},
			},
			{
				path: 'controlManage',
				component: ControlManage,
				meta: {
					name: '控制管理',
					comp: ControlManage,
				},
			},
			{
				path: 'electricReport',
				component: ElectricReport,
				meta: {
					name: '电表报表',
					comp: ElectricReport,
				},
			},
			{
				path: 'waterReport',
				component: WaterReport,
				meta: {
					name: '水表报表',
					comp: WaterReport,
				},
			},
			{
				path: 'dataReport',
				component: DataReport,
				meta: {
					name: '数据报表',
					comp: DataReport,
				},
			},
			{
				path: 'compareReport',
				component: CompareReport,
				meta: {
					name: '同比报表',
					comp: CompareReport,
				},
			},
			{
				path: 'billManage',
				component: BillManage,
				meta: {
					name: '账单管理',
					comp: BillManage,
				},
			},
			{
				path: 'areaManage',
				component: AreaManage,
				meta: {
					name: '区域管理',
					comp: AreaManage,
				},
			},
			{
				path: 'NBCard',
				component: NBCard,
				meta: {
					name: 'NB卡管理',
					comp: NBCard,
				},
			},
			{
				path: 'basicExcelTemplate',
				component: BasicExcelTemplate,
				meta: {
					name: '模板管理',
					comp: BasicExcelTemplate,
				},
			},
			{
				path: 'paramsManage',
				component: ParamsManage,
				meta: {
					name: '参数配置',
					comp: ParamsManage,
				},
			},
			{
				path: 'energyConsumptionReport',
				component: EnergyConsumptionReport,
				meta: {
					name: '能耗报表',
					comp: EnergyConsumptionReport,
				},
			},
			{
				path: 'dictionary',
				component: Dictionary,
				meta: {
					name: '字典管理',
					comp: Dictionary,
				},
			},
			{
				path: 'blacklistManagement',
				component: BlacklistManagement,
				meta: {
					name: '黑名单管理',
					comp: BlacklistManagement,
				},
			},
			{
				path: 'personnelManagement',
				component: PersonnelManagement,
				meta: {
					name: '人员管理',
					comp: PersonnelManagement,
				},
			},
			{
				path: 'priceManagement',
				component: PriceManagement,
				meta: {
					name: '价格管理',
					comp: PriceManagement,
				},
			},
			{
				path: 'concentratorManagement',
				component: ConcentratorManagement,
				meta: {
					name: '集中器管理',
					comp: ConcentratorManagement,
				},
			},
			{
				path: 'appletAccount',
				component: AppletAccount,
				meta: {
					name: '小程序账户管理',
					comp: AppletAccount,
				},
			},
		],
	},
];

const router = new VueRouter({
	routes,
});

// router.beforeEach((to,next) => {
//     // if(to.path == '/' || to.path == '/login')
//     // {
//     //     next();
//     //     return;
//     // }
//     // if(!this.$root.isLogin){
//     //     this.$router.push('/');
//     // }
//     alert(to.path);
//     next(to.path);
//
// });

export default router;
